import { type FC } from 'react';
import ExpandableFilterPanel from 'components/molecules/expandable-filter-panel';

import Body from './body';

import type {
  Filters,
  AppendFilters,
} from 'infrastructure/hooks/interactiveTimeDashboard/types';

interface Props {
  appendFilters: AppendFilters;
  filters: Filters;
  filtersCount: number;
  resetFilters: () => void;
}

const InteractiveTimeDashboardFilters: FC<Props> = ({
  filtersCount,
  appendFilters,
  resetFilters,
  filters,
}) => {
  return (
    <ExpandableFilterPanel filtersCount={filtersCount} onReset={resetFilters}>
      <Body filters={filters} appendFilters={appendFilters} />
    </ExpandableFilterPanel>
  );
};

export default InteractiveTimeDashboardFilters;
